
import { List, Modal } from "antd";
import { enqueueSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { GetCategoryDesignationsById } from "../../../API/api";
interface DesignationListType {
  categoryId: number;
  handleClosePopup: (data: boolean) => void;
}

const DesignationList: React.FC<DesignationListType> = ({
  categoryId,
  handleClosePopup,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [designationList, setDesignationList] = useState([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    GetDesignationList();
  }, []);

  const GetDesignationList = async () => {
    try {
      setIsLoading(true);
      const response = await GetCategoryDesignationsById(categoryId);
      setDesignationList(response.data);
    } catch (error: any) {
      enqueueSnackbar(error, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };
  const handleCloseDesignationPopup = () => {
    setIsOpen(false);
    handleClosePopup(true);
  };
  return (
    <Modal
      footer={null}
      title="Designation List"
      open={isOpen}
      onCancel={handleCloseDesignationPopup}
      maskClosable={false}
    >
      <List
        size="small"
        bordered
        dataSource={designationList}
        renderItem={(item:any) => <List.Item style={{margin: 10}}>{item.designation}</List.Item>}
      />
    </Modal>
  );
};
export default DesignationList;
